module.exports = __resourceQuery;


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/evaluate/resourceQuery/returnRQ.js?resourceQuery
 ** module id = 3
 ** module chunks = 0
 **/